var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "mb-2",
              attrs: { size: "small" },
              model: {
                value: _vm.filters.app,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "app", $$v)
                },
                expression: "filters.app"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: false } }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("i", { staticClass: "el-icon-monitor" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Desktop")])
                ])
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: true } }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("i", { staticClass: "el-icon-mobile" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("App")])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { size: "mini", "split-button": "", plain: "" },
                  on: { command: _vm.handleSetOrder }
                },
                [
                  _c("strong", [_vm._v("Ordernar")]),
                  _vm._v(
                    ": " +
                      _vm._s(
                        _vm.filters.orderBy == "latest" ? "Recentes" : "Antigos"
                      ) +
                      "\n                "
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "latest" } }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("i", { staticClass: "el-icon-top mr-2" }),
                            _vm._v(
                              "\n                            Mais Recentes\n                        "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "oldest" } }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("i", { staticClass: "el-icon-bottom mr-2" }),
                            _vm._v(
                              "\n                            Mais Antigos\n                        "
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "rounded",
          attrs: { data: _vm.data, align: "center", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Descrição", "min-width": "220", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "text-capitalize" }, [
                      _vm._v(_vm._s(scope.row.descricao.toLowerCase()))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            staticClass: "position-relative",
            attrs: { label: "Imagem", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-image",
                      {
                        style: {
                          width: "100%",
                          height: "100%",
                          position: "absolute",
                          inset: 0
                        },
                        attrs: {
                          src: scope.row.imagem,
                          "preview-src-list": ["" + scope.row.imagem],
                          fit: "cover"
                        }
                      },
                      [
                        _c("template", { slot: "error" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center border rounded",
                              style: { height: "100%" }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-picture-outline"
                              })
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Período de exibição",
              width: "300",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-itens-center",
                            style: { gap: "12px" }
                          },
                          [
                            scope.row.inicio_vigencia
                              ? _c("span", { staticClass: "ml-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        scope.row.inicio_vigencia,
                                        true
                                      )
                                    )
                                  )
                                ])
                              : _c(
                                  "el-tag",
                                  {
                                    staticClass: "ml-1",
                                    attrs: { size: "small", type: "info" }
                                  },
                                  [_vm._v("INDEFINIDO")]
                                ),
                            _vm._v(" "),
                            _c("span", [_c("strong", [_vm._v("-")])]),
                            _vm._v(" "),
                            scope.row.fim_vigencia
                              ? _c("span", { staticClass: "ml-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        scope.row.fim_vigencia,
                                        true
                                      )
                                    )
                                  )
                                ])
                              : _c(
                                  "el-tag",
                                  {
                                    staticClass: "ml-1",
                                    attrs: { size: "small", type: "info" }
                                  },
                                  [_vm._v("INDEFINIDO")]
                                )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Classe", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.classe
                      ? _c(
                          "el-tag",
                          { attrs: { size: "small", type: "primary" } },
                          [_vm._v(_vm._s(scope.row.classe))]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "small", type: "success" } },
                          [_vm._v("TODAS")]
                        )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Situação", width: "100", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: scope.row.ativo ? "success" : "danger"
                        }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(scope.row.ativo ? "ATIVO" : "INATIVO") +
                            "\n                "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Criado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.created_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { fixed: "right", align: "right", width: "50" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-end",
                                trigger: "click"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "mini",
                                    type: "info",
                                    plain: "",
                                    circle: "",
                                    disabled: _vm.loading
                                  },
                                  slot: "reference"
                                },
                                [_c("i", { staticClass: "el-icon-more" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    gap: "4px",
                                    maxWidth: "300px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Ações")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-divider", { staticClass: "my-1" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "warning",
                                            plain: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dispatchBannerEdit(
                                                scope.row.id
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Editar")])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "danger",
                                            plain: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dispatchBannerDelete(
                                                scope.row.id
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Excluir")])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticStyle: { width: "100%" },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_c("i", { staticClass: "el-icon-menu" })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("el-empty", {
                attrs: { description: "Nenhuma banner disponível" }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt-3" },
        [
          _c(
            "el-col",
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.data.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.data.perPage,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pagination.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("BannerEditModal", { ref: "bannerEdit", on: { updated: _vm.fetch } }),
      _vm._v(" "),
      _c("BannerDeleteModal", {
        ref: "bannerDelete",
        on: { deleted: _vm.fetch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33adfba2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33adfba2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/banner/BannerList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-33adfba2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/banner/BannerList.vue
// module chunks = 2